// extracted by mini-css-extract-plugin
export default {"icon":"app_icon__-Wi0W","navLinks":"app_navLinks__ScmYL","brand":"app_brand__-RIcA","links":"app_links__OJ5W-","categories":"app_categories__ibyL6"};